import React, { useMemo } from 'react';
import { Card, Col, Empty, Row, Typography } from 'antd';
import { BarChartOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { EnterprisePageHeader, WorkspaceLayout } from '@/components/enterprise';
import { filterReportsByPermissions, getReportsByModule } from '@/reports/registry/standardReports';
import { useAuthStore } from '@/store/authStore';

const { Paragraph } = Typography;

/** Recruitment report hub — every card opens the standard report runner (filters, print, CSV / Excel export). */
const RecruitReportsPage: React.FC = () => {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const reports = useMemo(
    () =>
      filterReportsByPermissions(
        getReportsByModule('hr').filter((r) => r.id.startsWith('hr.recruit_')),
        user?.permissions,
        user?.is_super_admin
      ),
    [user]
  );

  return (
    <WorkspaceLayout
      fullBleed
      header={<EnterprisePageHeader documentLabel="Recruitment reports" subtitle="Funnel, time to hire, sources, offers, workload, requisition ageing and onboarding" />}
    >
      {reports.length ? (
        <Row gutter={[12, 12]}>
          {reports.map((r) => (
            <Col xs={24} md={12} xl={8} key={r.id}>
              <Card hoverable size="small" onClick={() => navigate(r.route)} style={{ height: '100%' }}>
                <Card.Meta avatar={<BarChartOutlined style={{ fontSize: 22, color: '#1677ff' }} />} title={r.title} description={<Paragraph type="secondary" style={{ marginBottom: 0 }}>{r.description}</Paragraph>} />
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <Empty description="You do not have access to recruitment reports" />
      )}
    </WorkspaceLayout>
  );
};

export default RecruitReportsPage;
